import { NumberFormatter } from '@/context/configContext';
import { Typography } from '@analytical-alley/ui';

type CustomTooltipProps = {
    seriesName: string;
    color: string;
    value: number;
    axisValueLabel: string;
}[];

export const CustomTooltip = ({
    params,
    formatNumber,
}: {
    params: CustomTooltipProps;
    formatNumber: NumberFormatter;
}) => {
    return (
        <div className="tooltip-content max-w-[342px]">
            <Typography className="tooltip-header dark:text-dark text-white">
                {params[0]?.axisValueLabel}
            </Typography>
            <div className="flex gap-2 leading-4">
                <div className="flex flex-col space-y-2 text-neutral-800">
                    {params.map((param) => {
                        return (
                            <div key={param.seriesName} className="flex">
                                <span
                                    style={{
                                        backgroundColor: param.color,
                                    }}
                                    className="flex w-2.5 h-2.5 rounded-full me-1.5 shrink-0 self-center"
                                />
                                {param.seriesName}:
                            </div>
                        );
                    })}
                </div>
                <div className="flex flex-col space-y-2 flex-1 font-medium text-violet-950">
                    {params.map((param) => {
                        return (
                            <div
                                key={`${param.seriesName}-${param.value}`}
                                className="flex"
                            >
                                {formatNumber(param.value)}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
